import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const WAREHOUSE_BASE = "/warehouselocations";
const buildUrl = (endpoint) => WAREHOUSE_BASE + endpoint;
const ApiName = "WarehouseLocations";

const warehouseLocationsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getWarehouseLocations: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: ApiName}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getWarehouseLocations', ApiName)
        }),
        getWarehouseLocationSelect: builder.query({
            query: searchBody => ({
                url: buildUrl(`/select`),
                method: 'POST',
                body: searchBody,
            }),
            providesTags: (result, error, arg) => [{ type: ApiName }],
        }),
        getWarehouseLocation: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: ApiName, id }],
        }),
        getWarehouseLocationSp: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: ApiName, id }],
        }),
        updateWarehouseLocation: builder.mutation({
            query: locationInfo => ({
                url: buildUrl(`/${locationInfo.id}`),
                method: 'PUT',
                body: locationInfo,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName, id }],
        }),
        addWarehouseLocation: builder.mutation({
            query: locationInfo => ({
                url: buildUrl(`/add`),
                method: 'POST',
                body: locationInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: ApiName}],
        }),
        deleteWarehouseLocation: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName}],
        }),
        getDashboardWarehouseLocationTotals: builder.query({
            query: () => ({
                url: buildUrl(`/dashboard/totals`),
                method: 'GET',
            }),
        }),
        getDashboardWarehouseLocationChart: builder.query({
            query: (type) => ({
                url: buildUrl(`/dashboard/chart?type=${type}`),
                method: 'GET',
            }),
        }),
        exportWarehouseLocations: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/export`),
                method: 'POST',
                body: body,
                responseHandler: async (response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const jsonData = await response.json();

                    // Export finished within the timeout, so it can be downloaded right away
                    if (jsonData.blobUrl) {
                        const a = document.createElement('a');
                        a.href = jsonData.blobUrl;
                        a.download = jsonData.fileName || `magazijnlocaties_export_${new Date().toISOString().split('T')[0]}.xlsx`;
                        a.target = '_blank'; // Open in new tab as fallback
                        document.body.appendChild(a);
                        a.click();
                        a.remove();

                        return { success: true, message: jsonData.message, immediate: true };
                    }

                    // Still generating in the background, the user gets a notification when it is ready
                    return { success: true, processing: true, message: jsonData.message, exportId: jsonData.exportId };
                },
            }),
        }),
    })
});

export const { 
    useGetWarehouseLocationsQuery,
    useGetWarehouseLocationSelectQuery,
    useGetWarehouseLocationQuery,
    useUpdateWarehouseLocationMutation,
    useAddWarehouseLocationMutation,
    useGetWarehouseLocationSpQuery,
    useDeleteWarehouseLocationMutation,
    useGetDashboardWarehouseLocationTotalsQuery,
    useGetDashboardWarehouseLocationChartQuery,
    useExportWarehouseLocationsMutation
} = warehouseLocationsApiSlice;
